<template>
  <b-modal ref="user-card-modal" @ok="userCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.users.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="userName"
          :state="isUserNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.loginPage.passwordLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="password"
          type="password"
          :state="isPasswordValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.loginPage.confirmPasswordLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="confirmPassword"
          type="password"
          :state="isConfirmPasswordValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.firstName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="firstName"
          :state="isFirstNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.lastName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="lastName"
          :state="isLastNameValid"
          style="font-size: 13px"
          ></b-form-input>
        </b-form-group>
        
        <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.patronymic"
        label-for="input-horizontal"
        >
        <b-form-input
          v-model="patronymic"
          :state="isPatronymicValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.role"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="role"
          :options="roleOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.isActive"
        label-for="input-horizontal"
      >
        <b-form-checkbox
          v-model="isActive"
        >
        </b-form-checkbox>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.isActiveToUntillTime"
        label-for="input-horizontal"
      >

        <b-form-datepicker
          v-model="isActiveToUntillTime"
          :state="isActiveToUntillTimeValid"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.fuelDepo"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="fuelDepoId"
          :state="isFuelDepoValid"
          :options="fuelDepoOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
    <div v-if="!isFormValid" class="text-danger mt-2" style="font-size: 13px">
      {{ validationErrorMessage }}
    </div>
  </b-modal>
</template>

<script>

import { azkService, utilsService } from "../../../../services";

export default {
  name: "CreateUserPage",
  props: {
    fuelDepos: Array,
    users: Array,
  },
  components: {},
  data() {
    return {
      isFormValid: true,
      validationErrorMessage: null,
      fuelDepoOptions: [],
      userName: null,
      password: null,
      confirmPassword: null,
      lastName: null,
      firstName: null,
      patronymic: null,
      role: null,
      isActive: null,
      isActiveToUntillTime: null,
      fuelDepoId: null,
     
      isUserNameValid: null,
      isPasswordValid: null,
      isConfirmPasswordValid: null,
      isLastNameValid: null,
      isFirstNameValid: null,
      isPatronymicValid: null,
      isActiveToUntillTimeValid: null,
      isFuelDepoValid: null
    };
  },
  computed: {
    roleOptions() {
      const roleOptions = [];
      roleOptions.push("Admin");
      roleOptions.push("Operator");

      return roleOptions;
    },
    calendarLocale() {
      return utilsService.getCalendarLocale(this.$store.state.localization.locale);
    }
  },
  methods: {
    open() {
      this.userName = null;
      this.password = null;
      this.confirmPassword = null;
      this.firstName = null;
      this.lastName = null;
      this.patronymic = null;
      this.role = null;
      this.isActive = null;
      this.isActiveToUntillTime = null;

      this.validationErrorMessage = null;
      this.isUserNameValid = null;
      this.isPasswordValid = null;
      this.isConfirmPasswordValid = null;
      this.isLastNameValid = null;
      this.isFirstNameValid = null;
      this.fuelDepoId = null;
      this.isPatronymicValid = null;
      this.isActiveToUntillTimeValid = null;
      this.isFuelDepoValid = null;
      this.fuelDepoOptions = [];

      for (let i = 0; i < this.fuelDepos.length; i++) {
        this.fuelDepoOptions.push({
          value: this.fuelDepos[i].id,
          text: this.fuelDepos[i].name,
        });
      }

      this.$refs["user-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.userName) {
        this.isUserNameValid = false;
        isValid = false;
      } else {
        this.isUserNameValid = null;
      }

      if (!this.password) {
        this.isPasswordValid = false;
        isValid = false;
      } else {
        this.isPasswordValid = null;
      }

      if (!this.confirmPassword) {
        this.isConfirmPasswordValid = false;
        isValid = false;
      } else {
        this.isConfirmPasswordValid = null;
      }

      if (this.password == this.confirmPassword) {
        if (utilsService.isPasswordNotValid(this.password)) {
          this.isPasswordValid = false;
          this.isConfirmPasswordValid = false;
          this.validationErrorMessage = this.$store.state.localization.data.mainPage.azk.users.passwordNotHard;
          isValid = false;
        } else {
          this.isPasswordValid = null;
          this.isConfirmPasswordValid = null;
        }
      } else {
        this.isPasswordValid = false;
        this.isConfirmPasswordValid = false;
        this.validationErrorMessage = this.$store.state.localization.data.mainPage.azk.users.passwordMismatched;
        isValid = false;
      }

      if (!this.lastName) {
        this.isLastNameValid = false;
        isValid = false;
      } else {
        this.isLastNameValid = null;
      }

      if (!this.firstName) {
        this.isFirstNameValid = false;
        isValid = false;
      } else {
        this.isFirstNameValid = null;
      }

      if (!this.patronymic) {
        this.isPatronymicValid = false;
        isValid = false;
      } else {
        this.isPatronymicValid = null;
      }

      if (!this.isActiveToUntillTime) {
        this.isActiveToUntillTimeValid = false;
        isValid = false;
      } else {
        this.isActiveToUntillTimeValid = null;
      }

      if (!this.fuelDepoId) {
        this.isFuelDepoValid = false;
        isValid = false;
      } else {
        this.isFuelDepoValid = null;
      }

      this.isFormValid = isValid;
      return isValid;
    },
    async userCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      const fuelDepoId = parseInt(this.fuelDepoId);
      const user = this.users.find(x => x.fuelDepoId == fuelDepoId);

      const userCard = {
        userName: this.userName,
        password: this.password,
        firstName: this.firstName,
        lastName: this.lastName,
        patronymic: this.patronymic,
        role: this.role,
        isActive: this.isActive,
        clientId: user.clientId,
        isActiveToUntillTime: this.isActiveToUntillTime.getTime() / 1000,
        fuelDepoId: fuelDepoId,
      };

      const createUserResponse = await azkService.createUser(userCard);

      if (
        createUserResponse.isSuccess &&
        createUserResponse.data &&
        createUserResponse.data.countInsertedRows == 1
      ) {
        this.$emit("userCreatedSuccessEvent", this.user);
      } else {
        this.$emit("userCreatedFailEvent");
      }
    },
  },
};
</script>
